module.exports = __webpack_public_path__ + "static/cats-memory-b5b42b036c25e92fe305716166497100.png";